import { render, staticRenderFns } from "./WineList.vue?vue&type=template&id=afae163a"
import script from "./WineList.vue?vue&type=script&lang=ts"
export * from "./WineList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports